import { render, staticRenderFns } from "./RegisterPerson.vue?vue&type=template&id=3658c1ec"
import script from "./RegisterPerson.vue?vue&type=script&lang=js"
export * from "./RegisterPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports